export default __webpack_public_path__ + "static/media/Boots of the Crimson Fort.8e0b7567.jpg";